/**
 * Auth Provider Component
 * Initializes authentication state on app load
 */

import { useEffect } from 'react'
import { subscribeAuthStoreToSupabaseAuthChanges, useAuthStore } from '@/stores/auth-store'

interface AuthProviderProps {
  children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { isInitialized, initialize } = useAuthStore()

  // Initialize auth state on mount
  useEffect(() => {
    if (!isInitialized) {
      initialize()
    }
  }, [isInitialized, initialize])

  useEffect(() => subscribeAuthStoreToSupabaseAuthChanges(), [])

  // Auth state is being initialized in the background
  // We don't block rendering to allow the app to show loading states
  return <>{children}</>
}

export default AuthProvider
